import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'arrow-loop-right-2', 'ArrowLoopRight2', [["path",{"d":"M12 21v-6m0 -6v-1a4 4 0 1 0 -4 4h13"}],["path",{"d":"M17 16l4 -4l-4 -4"}]]);